<template>
  <span class="custom-title">Inspections</span>
  <ul class="custom-list">
    <li
      v-for="item of inspections"
      :key="item.adasInspection"
      @click="viewInspection(item.adasInspection)"
    >
      <div>
        <span class="custom-inspection"># {{ item.adasInspection }}</span>
        <span class="custom-inspection">{{ formatDate(item.created) }}</span>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'InspectionList',
  props: {
    row: Object
  },
  emits: ['view'],
  computed: {
    inspections() {
      let _inspections = []
      if (this.row) {
        _inspections = this.row.inspections
      }
      console.log(_inspections)
      return _inspections
    }
  },
  methods: {
    viewInspection(id) {
      this.$emit('view', this.row, id)
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString()
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-title {
  font-weight: 500;
  font-size: 1.1rem;
}
.custom-list {
  list-style-type: none;
  padding: 0;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  li {
    padding: 5px 0;
    border-bottom: 1px solid #e0e0e0;
    :hover {
      cursor: pointer;
      background-color: #fffeb7;
    }
    div {
      display: flex;
      justify-content: space-between;
    }
  }
}
.custom-inspection {
  font-size: 1.1rem;
  font-weight: 500;
  padding: 10px;
}
</style>
